"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResult = SearchResult;
var _react = _interopRequireDefault(require("react"));
var _OpenInNew = _interopRequireDefault(require("mdi-material-ui/OpenInNew"));
var _sanitizeHtml = _interopRequireDefault(require("../../../utils/sanitizeHtml"));
var _SearchResult = _interopRequireDefault(require("./SearchResult.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function SearchResult(_ref) {
  var title = _ref.title,
    ftsSnippetHtml = _ref.ftsSnippetHtml,
    fullUrl = _ref.fullUrl;
  var sanitizedContent = (0, _sanitizeHtml.default)(ftsSnippetHtml);
  var classes = (0, _SearchResult.default)();
  return /*#__PURE__*/_react.default.createElement("a", {
    href: fullUrl,
    target: "__blank",
    className: classes.resultContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.resultContent
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: classes.resultTitle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.title
  }, title, " ", /*#__PURE__*/_react.default.createElement(_OpenInNew.default, {
    className: classes.openIcon
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.resultPreview
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: sanitizedContent
    }
  })));
}